<mat-label class="subHeading">No of members<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="memberCountForm" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="1" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="1" (keyup)="change()" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="
    memberCountForm.controls['from'].hasError('small')
    ||
    memberCountForm.controls['to'].hasError('small')
"
  
>
Invalid range for values
</p>
